import { Box, HStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import Button from 'components/Button';
import Icon from 'components/Icon';
import Modal from 'components/Modal';
import Text from 'components/Text';
import { ERoute, IModal } from 'types/frontend';

interface IAccountTerminatedModal extends IModal {}

export const AccountTerminatedModal = ({ isOpen, onClose }: IAccountTerminatedModal) => {
  const navigate = useNavigate();
  return (
    <Modal
      size="md"
      isOpen={isOpen}
      onClose={onClose}
      header={
        <HStack>
          <Icon type="DeleteModal" />
          <Text fontSize="xLarge" fontWeight="semibold">
            Your account is terminated
          </Text>
        </HStack>
      }
      footer={
        <Box position="relative">
          <Button scheme="ghost" onClick={onClose} mr={1}>
            Close
          </Button>
          <Button onClick={() => navigate(ERoute.Plans)}>Go to pricing</Button>
        </Box>
      }
    >
      <Text fontWeight="regular">
        You need to renew your subscription to continue using these features. Go to the pricing page{' '}
        to choose a new plan.
      </Text>
    </Modal>
  );
};
